


<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<ng-container *ngIf="subtitle">
  <h6 class="mx mt subtitle mb-none">{{subtitle}}</h6>
</ng-container>
<h1 class="mx mb-sm {{styleClass}}" [ngClass]="{'mt' : !subtitle, 'my-none': subtitle}">
  <ng-content select="[title]"></ng-content> {{title}}
</h1>


